import React from 'react';

/**
 * Empty-state card shown when the filter combination returns no cells.
 * Friendly copy + a nudge on what to try next.
 */
export function HeatmapEmptyState({
  sinceDays,
  minN,
  onReset,
}: {
  sinceDays: number;
  minN: number;
  onReset: () => void;
}) {
  return (
    <div
      className="bg-bg-elevated border border-border-base rounded-lg p-8 text-center"
      data-testid="heatmap-empty"
    >
      <p className="text-fg-primary text-base font-semibold">
        No engagement data yet.
      </p>
      <p className="text-fg-muted text-sm mt-2">
        No precinct had at least {minN} knocks in the last {sinceDays} days.
        Try widening the lookback window, switching to a coarser bucket, or
        lowering the min-knocks filter.
      </p>
      <button
        type="button"
        onClick={onReset}
        className="mt-4 inline-flex items-center justify-center min-h-[44px] px-4 py-2 rounded bg-accent hover:opacity-90 text-white text-sm font-semibold"
      >
        Reset filters
      </button>
    </div>
  );
}
